import { AlertTriangle } from "lucide-react";

export default function DisclaimerSection() {
  return (
    <section
      id="disclaimer"
      className="bg-[#070707] py-16"
      data-testid="section-disclaimer"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="rounded-2xl border border-white/10 p-6 md:p-8 bg-[#0c0c0c] flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 flex items-center justify-center shrink-0">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-white font-semibold tracking-tight">Safety Disclaimer</h3>
            <p className="mt-2 text-sm text-white/65 leading-relaxed">
              NFP provides fitness and performance training guidance. It does
              not diagnose, treat, or cure medical conditions. Users
              with injuries, medical conditions, pain, or exercise restrictions
              should consult a qualified healthcare professional before
              beginning a fitness program. Stop exercising and seek appropriate
              care if unusual symptoms occur.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
